import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DetailedSectionEvaluation } from '../../../redux/types';

const SuperScript = styled('span')`
  vertical-align: super;
  font-size: 0.8em;
  margin-left: 2px;
  font-weight: 500;
  color: black;
`;

type AnswersBySamples = DetailedSectionEvaluation['questions']['id']['answersBySamples'][0];
type Props = {
  answers: AnswersBySamples['cumulatedAnswers'];
  submissionerAnswer: AnswersBySamples['submissionerAnswer'];
}

class AnswerChart extends Component<Props> {
  // A single choice question will have a string type of answer
  static isQuestionSingleChoice = (submissionerAnswer: string): boolean => typeof submissionerAnswer === 'string';

  static isSubmissionersAnswer = (
    answerKey: string,
    submissionerAnswer: any,
  ): boolean => {
    switch (typeof submissionerAnswer) {
      case 'string':
        return answerKey === submissionerAnswer;
      case 'object':
        return !!submissionerAnswer[answerKey];
      case 'undefined':
        return false;
      default:
        throw new Error(`Source for detecting submissioners answer failed due to unknown type: ${JSON.stringify(submissionerAnswer, null, 2)}`);
    }
  };

  render(): JSX.Element {
    const {
      answers,
      submissionerAnswer,
    } = this.props;
    return (
      <Box
        className="basis-100"
        display="flex"
        flexWrap="wrap"
        flexDirection="column"
        justifyContent="space-evenly"
        alignContent="space-around"
        height="100%"
      >
        {
          Object.keys(answers).map((answerKey) => (
            <div
              key={answerKey}
            >
              <Typography
                component="p"
                sx={AnswerChart.isSubmissionersAnswer(answerKey, submissionerAnswer) ? {
                  color: '#0C7BDC',
                  fontWeight: 600,
                } : null}
                className="ma0"
              >
                <span>
                  {answers[answerKey].value}
                </span>
                <SuperScript>
                  (
                  {answers[answerKey].score}
                  )
                </SuperScript>
              </Typography>
            </div>
          ))
        }
      </Box>
    );
  }
}

export default AnswerChart;
